var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { generateReducer } from "../generators/generator.reducer";
import { addRegistrationDocumentStart, addRegistrationDocumentSucceeded, addRegistrationDocumentFailed, updateRegistrationDocumentStart, updateRegistrationDocumentSucceeded, updateRegistrationDocumentFailed, deleteRegistrationDocumentStart, deleteRegistrationDocumentSucceeded, deleteRegistrationDocumentFailed, } from "./rentRegistrationDocuments.actions";
import { GENERATOR_PARAMS } from "./rentRegistrationDocuments.constants";
var getDefaultState = function () { return ({
    registrationsById: {},
}); };
var _reducer = generateReducer(GENERATOR_PARAMS, getDefaultState);
var reducer = _reducer;
reducer.on(addRegistrationDocumentStart.type, function (state, _a) {
    var _b;
    var registrationId = _a.registrationId;
    return __assign(__assign({}, state), { registrationsById: (_b = {},
            _b[registrationId] = __assign(__assign({}, state.registrationsById[registrationId]), { isUpdating: true, updateError: undefined }),
            _b) });
});
reducer.on(addRegistrationDocumentSucceeded.type, function (state, _a) {
    var _b;
    var registrationId = _a.registrationId;
    return __assign(__assign({}, state), { registrationsById: (_b = {},
            _b[registrationId] = __assign(__assign({}, state.registrationsById[registrationId]), { isUpdating: false, updateError: undefined }),
            _b) });
});
reducer.on(addRegistrationDocumentFailed.type, function (state, _a) {
    var _b;
    var registrationId = _a.registrationId, error = _a.error;
    return __assign(__assign({}, state), { registrationsById: (_b = {},
            _b[registrationId] = __assign(__assign({}, state.registrationsById[registrationId]), { isUpdating: false, updateError: error }),
            _b) });
});
reducer.on(updateRegistrationDocumentStart.type, function (state, _a) {
    var _b;
    var registrationId = _a.registrationId;
    return __assign(__assign({}, state), { registrationsById: (_b = {},
            _b[registrationId] = __assign(__assign({}, state.registrationsById[registrationId]), { isUpdating: true, updateError: undefined }),
            _b) });
});
reducer.on(updateRegistrationDocumentSucceeded.type, function (state, _a) {
    var _b;
    var registrationId = _a.registrationId;
    return __assign(__assign({}, state), { registrationsById: (_b = {},
            _b[registrationId] = __assign(__assign({}, state.registrationsById[registrationId]), { isUpdating: false, updateError: undefined }),
            _b) });
});
reducer.on(updateRegistrationDocumentFailed.type, function (state, _a) {
    var _b;
    var registrationId = _a.registrationId, error = _a.error;
    return __assign(__assign({}, state), { registrationsById: (_b = {},
            _b[registrationId] = __assign(__assign({}, state.registrationsById[registrationId]), { isUpdating: false, updateError: error }),
            _b) });
});
reducer.on(deleteRegistrationDocumentStart.type, function (state, _a) {
    var _b;
    var registrationId = _a.registrationId;
    return __assign(__assign({}, state), { registrationsById: (_b = {},
            _b[registrationId] = __assign(__assign({}, state.registrationsById[registrationId]), { isUpdating: true, updateError: undefined }),
            _b) });
});
reducer.on(deleteRegistrationDocumentSucceeded.type, function (state, _a) {
    var _b;
    var registrationId = _a.registrationId;
    return __assign(__assign({}, state), { registrationsById: (_b = {},
            _b[registrationId] = __assign(__assign({}, state.registrationsById[registrationId]), { isUpdating: false, updateError: undefined }),
            _b) });
});
reducer.on(deleteRegistrationDocumentFailed.type, function (state, _a) {
    var _b;
    var registrationId = _a.registrationId, error = _a.error;
    return __assign(__assign({}, state), { registrationsById: (_b = {},
            _b[registrationId] = __assign(__assign({}, state.registrationsById[registrationId]), { isUpdating: false, updateError: error }),
            _b) });
});
// eslint-disable-next-line import/no-default-export
export default reducer;
